import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function SparklesIcon({ className, width = 14, height = 14 }: IconProps) {
    return (
        <svg
            className={cn('fill-current', className)}
            data-name='Layer 1'
            viewBox='0 0 24 24'
            width={width}
            height={height}
        >
            <path d='M19.5 24a1 1 0 01-.929-.628l-.844-2.113-2.116-.891a1.007 1.007 0 01.035-1.857l2.088-.791.837-2.092a1.008 1.008 0 011.858 0l.841 2.1 2.1.841a1.007 1.007 0 010 1.858l-2.1.841-.841 2.1A1 1 0 0119.5 24zM10 21a2 2 0 01-1.936-1.413L6.45 14.54l-5.063-1.694a2.032 2.032 0 01.052-3.871l5.023-1.534 1.692-5.054A1.956 1.956 0 0110.108 1a2 2 0 011.917 1.439l1.532 5.015 5.03 1.61a2.042 2.042 0 010 3.872l-5.039 1.612-1.612 5.039A2 2 0 0110 21zM20.5 7a1 1 0 01-.97-.757l-.357-1.43-1.433-.385a1 1 0 01.034-1.94l1.4-.325.356-1.406a1 1 0 011.94 0l.354 1.418 1.418.355a1 1 0 010 1.94l-1.418.355-.354 1.418A1 1 0 0120.5 7z' />
        </svg>
    );
}

export default SparklesIcon;

